import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
// import store from "@/store";
import { getCookie, removeCookie } from '@/utils/auth'

axios.defaults.withCredentials = false
const service = axios.create({
  //* *****打包时注意修改基础接口地址********/
  baseURL: 'http://www.mecanart.com/api',
  // baseURL: 'http://www.mecanart.com/v2/api',
  // baseURL: 'http://www.mecanart.com/v3/api',
  // baseURL: 'http://www.mecanart.com/v4/api',
  // baseURL: 'http://www.mecanart.com/v5/api',
  // baseURL: 'http://www.mecanart.com/v6/api',

  // baseURL: 'http://dev.mecanart.com/v2/api', // 开发环境
  timeout: 30 * 60 * 1000
})
service.interceptors.request.use(
  config => {
    const token = getCookie('token')
    // console.log(token)
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    if (response.status === 200) {
      if (res.code == 4001) {
        removeCookie('token')
        MessageBox.confirm('登录信息过期，请重新登录', '确认退出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeCookie('token')
          location.reload()
        })
        return ''
      }
      if (res.code !== 200) {
        Message({
          type: 'error',
          duration: 3000,
          message: `${res.msg}`,
          center: true
        })
      }
      return res
    } else {
      return Promise.reject(res.message)
    }
  },
  error => {
    // 服务器返回不是 2 开头的情况，会进入这个回调
    console.log(error)
    const responseCode = error.response.status
    switch (responseCode) {
      // 401token过期
      case 4001:
        // to re-login
        MessageBox.confirm('登录信息过期，请重新登录', '确认退出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeCookie('token')
          this.$router.push('/login')
        })
        break
      // 404请求不存在
      case 404:
        Message({
          message: '网络请求不存在',
          type: 'error'
        })
        break
      // 422参数错误
      case 422:
        Message({
          message: `请检查参数${error.response.data.msg}`,
          type: 'error'
        })
        break
      // 其他错误，直接抛出错误提示
      default:
        Message({
          message: `连接错误${error.response.status}`,
          type: 'error'
        })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js